var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"project-name-table-cell",class:{ viewable: _vm.canViewProjectDetails },on:{"click":_vm.goToProjectDetails}},[_c('div',{staticClass:"name"},[_vm._v(" "+_vm._s(_vm.item.asset)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }